import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";

const data = [
  { name: "FY 2022", registered: 30, resolved: 25, notResolved: 5 }
];

const ComplaintChart = (props) => {
  return (
    <div style={{ width: "100%" }}>
      <h3
        style={{
          marginBottom: "20px",
          color: "rgb(0 0 0 / 73%)",
          fontSize: 14,
          fontWeight: 600,
          marginLeft: 10,
        }}
      >
        {props?.title}
      </h3>
      <ResponsiveContainer width="100%" height={200}>
        <BarChart
          data={props.data}
          margin={{
            top: 10,
            right: 10,
            left: 0,
            bottom: 0,
          }}
        >
          {/* Add Grid */}
          <CartesianGrid strokeDasharray="2 2" vertical={false} />

          {/* X Axis */}
          <XAxis
            dataKey="name" // Corrected to 'name' which exists in your data
            tick={{ fontSize: 12, fontWeight: "bold" }}
            
          />

          {/* Y Axis */}
          <YAxis
            tick={{ fontSize: 12, fontWeight: "bold" }}
         
            domain={[0, 50]} // Adjust the domain as needed for your data range
          />
          <Bar
            dataKey="registered"
            fill="#4285F4"
            radius={[4, 4, 0, 0]} // Rounded corners for top of bars
            barSize={20} // Adjust bar width for a clean design
          >
            {/* Labels on Bars */}
            <LabelList
              dataKey="registered"
              position="top"
              style={{ fontSize: 12, fontWeight: "bold" }}
            />
          </Bar>
          <Bar
            dataKey="resolved"
            fill="#FB8C00"
            radius={[4, 4, 0, 0]} // Rounded corners for top of bars
            barSize={20} // Adjust bar width for a clean design
          >
            {/* Labels on Bars */}
            <LabelList
              dataKey="resolved"
              position="top"
              style={{ fontSize: 12, fontWeight: "bold" }}
            />
          </Bar>
          <Bar
            dataKey="notResolved"
            fill="rgb(94, 149, 151)"
            radius={[4, 4, 0, 0]} // Rounded corners for top of bars
            barSize={20} // Adjust bar width for a clean design
          >
            {/* Labels on Bars */}
            <LabelList
              dataKey="notResolved"
              position="top"
              style={{ fontSize: 12, fontWeight: "bold" }}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      <div className="chart-legend">
        <div className="legend-item">
          <div className="legend-color closed" style={{backgroundColor:"rgba(37, 99, 235, 1)"}}></div>
          <span>Complaints Registered</span>
        </div>
        <div className="legend-item">
          <div className="legend-color open" style={{backgroundColor:"rgba(237, 125, 49, 1)"}}></div>
          <span>Resolved</span>
        </div>
        <div className="legend-item">
          <div className="legend-color closed" style={{backgroundColor:"rgba(94, 149, 151, 1)"}}></div>
          <span>Not Resolved</span>
        </div>
      </div>
    </div>
  );
};

export default ComplaintChart;
